import EOS from 'eosjs';

var eosApi = EOS({
  httpEndpoint: 'https://api.tokenika.io',
  chainId: 'aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906',
})


export {eosApi}



// WEBPACK FOOTER //
// ./src/api.js